export enum LogStatus {
    None,
    Error,
    Info,
    Warning
}